import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatCard, MatCardHeader, MatCardTitle, MatCardContent, MatCardActions } from '@angular/material/card';
import { MatDivider } from '@angular/material/list';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-customer-details-component',
    templateUrl: './customer-details-component.component.html',
    styleUrls: ['./customer-details-component.component.scss'],
    imports: [MatCard, MatCardHeader, MatCardTitle, MatDivider, MatCardContent, MatCardActions, MatButton]
})
export class CustomerDetailsComponentComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<CustomerDetailsComponentComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}
    achRecord: any;

    ngOnInit(): void {
        this.achRecord = this.data;
    }

    onCloseButton(): void {
      this.dialogRef.close();
    }


}
